import React from "react";
import { MDBBadge, MDBBtn } from "mdbreact";
import { currency } from "../../../../../../services/utilities";
import { clean, getDepartment, getTemplateName, lowestPrice } from "../utils";

const Header = ({ service, menus = [], isOpen, textColor, index, setActiveId }) => {
  const { name, abbreviation, department, template, specimen } = service;
  const { text, color } = getDepartment(department),
    section = getTemplateName(template, department),
    price = lowestPrice(menus),
    toggle = () => setActiveId((prev) => (index === prev ? -1 : index));

  return (
    <div
      className={`d-flex justify-content-between align-items-center cursor-pointer ${textColor}`}
      onClick={toggle}
    >
      <div style={{ minWidth: 0 }}>
        <div className="d-flex align-items-center flex-wrap">
          <span className="font-weight-bold mr-2">{name}</span>
          {clean(abbreviation) && (
            <MDBBadge color="light" className="mr-2 text-dark">
              {abbreviation}
            </MDBBadge>
          )}
        </div>
        <small className="d-block text-muted text-truncate">
          <MDBBadge color={color} className="mr-2">
            {text}
          </MDBBadge>
          {section && <span className="mr-2">{section}</span>}
          {clean(specimen) && (
            <span title="Specimen">
              · {specimen}
            </span>
          )}
        </small>
      </div>
      <div className="d-flex align-items-center text-nowrap ml-3">
        <div className="text-right mr-3">
          {menus.length ? (
            <>
              <div className="font-weight-bold text-success">
                {price === Infinity
                  ? "No price"
                  : `${menus.length > 1 ? "from " : ""}${currency.format(price)}`}
              </div>
              <small className="text-muted">
                in {menus.length} menu{menus.length > 1 ? "s" : ""}
              </small>
            </>
          ) : (
            <MDBBadge
              color="light"
              className="text-muted"
              title="Not included in any menu of this branch, so it can not be sold yet"
            >
              Not offered
            </MDBBadge>
          )}
        </div>
        <MDBBtn
          size="sm"
          color="white"
          rounded
          className="m-0 p-0 transition-all"
          style={{ width: isOpen ? "1.5rem" : "2rem" }}
        >
          <i
            style={{ rotate: `${isOpen ? 0 : 90}deg` }}
            className="fa fa-angle-down transition-all"
          />
        </MDBBtn>
      </div>
    </div>
  );
};

export default Header;
